<template>

    <div id="doctor-register-container" class="m-auto">
        <div class="card o-hidden border-0 shadow-lg my-5">
            <div class="card-body p-0">
                <div class="row">
                    <div class="p-5 w-100">
                        <div class="text-center">
                            <h1 class="h4 text-gray-900 mb-4">
                                <span>{{$t('REGISTRATION_FORM')}}</span>
                            </h1>
                        </div>

                        <b-alert
                            :show="dismissCountDown"
                            dismissible
                            fade
                            :variant="response.success === true ? 'success' : 'danger' "
                            @dismissed="dismissCountDown = 0"
                            >
                            {{response.message}}
                        </b-alert>

                        <form class="user" @submit.prevent="addDoctorProfile">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.firstName" type="text" class="form-control form-control-user" :placeholder="$t('FIRST_NAME')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.lastName" type="text" class="form-control form-control-user" :placeholder="$t('LAST_NAME')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.email" type="email" class="form-control form-control-user" :placeholder="$t('EMAIL')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input v-model="doctorProfile.phoneNumber" type="text" :placeholder="$t('PHONE')"  class="form-control form-control-user">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input v-model="doctorProfile.city" type="text" :placeholder="$t('CITY')" class="form-control form-control-user" >
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input v-model="doctorProfile.address" type="text" :placeholder="$t('ADDRESS')" class="form-control form-control-user">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.riziv" type="text"  :placeholder="$t('RIZIV')" class="form-control form-control-user">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input v-model="doctorProfile.postcode" type="text" :placeholder="$t('POSTCODE')" class="form-control form-control-user">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.password" type="password" class="form-control form-control-user" :placeholder="$t('PASSWORD')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input v-model="doctorProfile.confirmedPassword" type="password" class="form-control form-control-user" :placeholder="$t('REPEAT_PASSWORD')">
                                    </div>
                                </div>
                            </div>
                            
                            <button type="submit" class="btn btn-primary btn-user btn-block">{{$t('REGISTER')}}</button>
                            <hr>
                            <div class="d-flex">
                                <router-link class="small" to="login">{{$t('LOGIN')}}</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            languages: [],
            selectedLanguage: null,
            doctorProfile :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "password": "",
                "confirmedPassword": "",
                "riziv": "",
                "phoneNumber": "",
                "city": "",
                "postcode": "",
                "address": "",
                "language": {},
                "languageId": ""
            },
            response: {
                success: null,
                message: "",
                doctorId: null
            },
            dismissCountDown: 0,
        }
    },
    methods: {
        onSelect: function(value){
            this.selectedLanguageId = value;
        },
        selectLanguage: function (language) {
                this.$store.dispatch('selectLanguage', language);
                this.selectedLanguage = this.$store.getters.selectedLanguage;
            },
            loadSystemLanguages: function () {
                let self = this;
                this.$store.dispatch('loadSystemLanguages')
                .then(response => {
                    self.languages = response.data;
                    self.selectedLanguage = self.languages[0];
                })
                .catch(error => {
                    console.log(error);
                })
            },
        addDoctorProfile: function(){
            let self = this;
            this.$http.post(`/api/doctor/register?languageCode=${ this.$store.getters.selectedLanguage.title }`, this.doctorProfile)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        }
        // getLanguages: function(){
        //     let self = this;
        //     this.$http.get("/api/languages/list")
        //         .then(response =>
        //         {
        //             self.languages = response.data;
        //             self.selectedLanguageObj = JSON.parse(JSON.stringify(self.languages[1]));
        //             self.doctorProfile.languageId = self.selectedLanguageObj.id;
        //         })
        //         .catch();
        // },
        // onSelect: function(value){
        //     this.selectedLanguageId = value;
        // }
    },
    mounted: function () {
        this.loadSystemLanguages();
    },
    watch: {
        response: function(val){
            this.dismissCountDown = 3;
            if(val.success === true){
                for (var key in this.doctorProfile ) 
                    this.doctorProfile[key] = '';
                setTimeout(() => {
                    this.$router.push("/confirm-email");
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000)
        },
        // selectedLanguageId: function(val){
        //     this.doctorProfile.languageId = val;
        //     this.selectedLanguageObj = this.languages.find(obj => {
        //         return obj.id === val;
        //     })
        //     this.doctorProfile.language = JSON.parse(JSON.stringify(this.selectedLanguageObj));
        // },
        // languages: function(val){
        //     this.doctorProfile.languageId = this.languages[0].id;
        // }
    }
}
</script>
<style lang="scss" scoped>
    @import "./../../../src/assets/scss/style";
    @import "~bootstrap/dist/css/bootstrap.css";
    
.rounded-circle {
    height : 1.5rem;
    width : 1.5rem;
}
#doctor-register-container {
    max-width: 620px;
}
#languageDropdown {
        color: #39566e;
        .rounded-circle {
           height: 1.7rem;
           width: 1.7rem;
           box-shadow: 0px 0px 1px $gray-500;
        }
    }

    #language-dropdown-items-container {
        width: auto !important;
    }

    .language-dropdown-item {
        .rounded-circle {
           box-shadow: 0px 0px 1px $gray-500;
        }
    }
</style>

